import { createAction } from "redux-actions";

import * as actionTypes from "../constants/actionTypes";

// editor
export const selectEditorSurface = id => ({ type: actionTypes.SELECT_EDITOR_SURFACE, id })
export const selectEditorPattern = id => ({ type: actionTypes.SELECT_EDITOR_PATTERN, id})
export const updateEditorLeftPanelStatus = status => ({ type: actionTypes.UPDATE_EDITOR_LEFT_PANEL_STATUS, status })
export const updateEditorRightPanelStatus = status => ({ type: actionTypes.UPDATE_EDITOR_RIGHT_PANEL_STATUS, status })
export const updateEditorPreviewStatus = status => ({ type: actionTypes.UPDATE_EDITOR_PREVIEW_STATUS, status })
export const toggleEditorPreviewrFullscreen = () => ({ type: actionTypes.TOGGLE_EDITOR_PREVIEW_FULLSCREEN })
export const updateEditorPatternConfigs = (id, config) => ({ type: actionTypes.UPDATE_EDITOR_PATTERN_CONFIGS, id, config })
export const clearEditor = () => ({ type: actionTypes.CLEAR_EDITOR })
export const createEditorConfigs = () => ({ type: actionTypes.CREATE_EDITOR_CONFIGS })
export const saveEditorConfigs = () => ({ type: actionTypes.SAVE_EDITOR_CONFIGS })
export const setEditorModel = (payload) => ({ type: actionTypes.SET_EDITOR_MODEL, payload })

// modals
export const openModal = ({ modalType, modalProps = {} }) => ({
  type: actionTypes.MODAL_OPEN,
  modalType,
  modalProps
})
export const closeModal = createAction(actionTypes.MODAL_CLOSE, payload => payload)
export const confirmModal = createAction(actionTypes.MODAL_CONFIRMED, payload => payload)

// folders
export const createFolder =  createAction(actionTypes.CREATE_FOLDER, payload => payload)
export const updateFolder = createAction(actionTypes.UPDATE_FOLDER, payload => payload)
export const fetchFolders = createAction(actionTypes.FETCH_FOLDERS, payload => payload)
export const setFolder    = createAction(actionTypes.SET_FOLDER, payload => payload)
export const setFolders   = createAction(actionTypes.SET_FOLDERS, payload => payload)
export const deleteFolder = createAction(actionTypes.DELETE_FOLDER, payload => payload)
export const unsetFolder  = createAction(actionTypes.UNSET_FOLDER, payload => payload)

// models
export const createModel =  createAction(actionTypes.CREATE_MODEL, payload => payload)
export const updateModel = createAction(actionTypes.UPDATE_MODEL, payload => payload)
export const fetchModel  = createAction(actionTypes.FETCH_MODEL, payload => payload)
export const fetchModels = createAction(actionTypes.FETCH_MODELS, payload => payload)
export const setModel    = createAction(actionTypes.SET_MODEL, payload => payload)
export const setModels   = createAction(actionTypes.SET_MODELS, payload => payload)
export const deleteModel = createAction(actionTypes.DELETE_MODEL, payload => payload)
export const unsetModel  = createAction(actionTypes.UNSET_MODEL, payload => payload)
export const modelNotFound  = createAction(actionTypes.MODEL_NOT_FOUND, payload => payload)

// model exports
export const createModelExport = createAction(actionTypes.CREATE_MODEL_EXPORT, payload => payload)
export const fetchModelExport = createAction(actionTypes.FETCH_MODEL_EXPORT, payload => payload)
export const setModelExport = createAction(actionTypes.SET_MODEL_EXPORT, payload => payload)
export const clearModelExport = createAction(actionTypes.CLEAR_MODEL_EXPORT, payload => payload)

// user
export const fetchUser = createAction(actionTypes.FETCH_USER, payload => payload)
export const setUser = createAction(actionTypes.SET_USER, payload => payload)
export const updateUser = createAction(actionTypes.UPDATE_USER, payload => payload)
export const unsetUser = createAction(actionTypes.UNSET_USER, payload => payload)
export const updateUserHasVisited = createAction(actionTypes.UPDATE_USER_HAS_VISITED, payload => payload)
export const deleteUser = createAction(actionTypes.DELETE_USER, payload => payload)
export const fetchUserAdminResources = createAction(actionTypes.FETCH_USER_ADMIN_RESOURCES, payload => payload);
export const fetchUserAdminResourcesSucceeded = createAction(actionTypes.FETCH_USER_ADMIN_RESOURCES_SUCCEEDED, payload => payload);
export const fetchUserAdminResourcesFailed = createAction(actionTypes.FETCH_USER_ADMIN_RESOURCES_FAILED, payload => payload);

// auth
export const resetPassword = createAction(actionTypes.RESET_PASSWORD, payload => payload)
export const signup = createAction(actionTypes.SIGNUP, payload => payload)
export const signin = createAction(actionTypes.SIGNIN, payload => payload)
export const securitySignin = createAction(actionTypes.SECURITY_SIGNIN, payload => payload)
export const signout = createAction(actionTypes.SIGNOUT, payload => payload)
export const setLoaded = createAction(actionTypes.SET_LOADED, payload => payload)

// ui
export const openUILeftSidebar = createAction(actionTypes.UI_OPEN_LEFT_SIDEBAR);
export const openUIRightSidebar = createAction(actionTypes.UI_OPEN_RIGHT_SIDEBAR);
export const closeUILeftSidebar = createAction(actionTypes.UI_CLOSE_LEFT_SIDEBAR);
export const closeUIRightSidebar = createAction(actionTypes.UI_CLOSE_RIGHT_SIDEBAR);
export const showUIHeader = createAction(actionTypes.UI_SHOW_HEADER);
export const hideUIHeader = createAction(actionTypes.UI_HIDE_HEADER);
export const showUISupportCard = createAction(actionTypes.UI_SHOW_SUPPORT_CARD);
export const hideUISupportCard = createAction(actionTypes.UI_HIDE_SUPPORT_CARD);
export const setUIEditor = createAction(actionTypes.UI_SET_EDITOR, payload => payload);

// locale
export const setLocaleLng = createAction(actionTypes.SET_LOCALE_LNG, payload => payload);

// contact
export const createContact = createAction(actionTypes.CREATE_CONTACT, payload => payload);
export const setContactSuccess = createAction(actionTypes.SET_CONTACT_SUCCESS);
export const unsetContactSuccess = createAction(actionTypes.UNSET_CONTACT_SUCCESS);



// WEBPACK FOOTER //
// ./src/constants/actions.js